import { useTranslation } from 'react-i18next';
import { SUPPLIER_REQUEST_STATUS } from './model/constants';

interface RequestStatusBadgeProps {
    status: number;
}

const statusMeta: Record<number, { key: string; bg: string }> = {
    [SUPPLIER_REQUEST_STATUS.ACTIVE]: { key: 'active', bg: 'bg-primary' },
    [SUPPLIER_REQUEST_STATUS.DONE]: { key: 'done', bg: 'bg-success' },
    [SUPPLIER_REQUEST_STATUS.DELETED]: { key: 'deleted', bg: 'bg-secondary' },
};

const RequestStatusBadge = ({ status }: RequestStatusBadgeProps) => {
    const { t } = useTranslation(['Vendors']);
    const meta = statusMeta[status] || statusMeta[SUPPLIER_REQUEST_STATUS.ACTIVE];

    return (
        <span className={`badge ${meta.bg} fs-12`}>
            {t(`supplierRequests.statusBadge.${meta.key}`)}
        </span>
    );
};

export default RequestStatusBadge;
